module.exports = __webpack_public_path__ + "img/MultipleUser.a2b4497a.svg";